import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-brand-green-dark text-white py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <h3 className="text-xl font-bold text-brand-gold">CarbonSasa</h3>
          <p className="text-sm text-gray-300">Monitor your green impact.</p>
        </div>
        
        <div className="flex space-x-6 text-sm text-gray-300">
          <a href="#!" className="hover:text-brand-gold transition-colors">About Us</a>
          <a href="#!" className="hover:text-brand-gold transition-colors">Privacy Policy</a>
          <a href="#!" className="hover:text-brand-gold transition-colors">Contact</a>
        </div>
        
        <div className="mt-4 md:mt-0 text-xs text-gray-400">
          &copy; {new Date().getFullYear()} CarbonSasa. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;